import { gql } from '@apollo/client'

const GET_LESSON_TYPE_DESCRIPTION = gql`
  query GetLessonTypeDescription($id: ID!) {
    lessonTypes(id: $id) {
      id
      description
    }
  }
`

// Selected only when virtual coaching is enabled so the shared queries keep
// working against schemas that do not expose these fields yet.
const VIRTUAL_COACHING_FIELDS = `
  offeringKind
  virtualCoaching {
    turnaroundHours
    purchaseLimit
    purchaseLimitPeriod
    expiresAt
  }
`

const LESSON_TYPE_DETAILS_FIELDS = gql`
  fragment LessonTypeDetailsFields on LessonType {
    id
    slug
    category
    title
    durationInMinutes
    locations {
      id
      name
    }
    coach {
      externalId
      coachProfile {
        slug
      }
    }
    status
    lessonPacks {
      quantity
      priceInCents
      expirationDuration
    }
    acceptsOnlinePayments
    priceInCents
    paymentAccount {
      deletedAt
      chargesEnabled
      payoutsEnabled
    }
    accessCode
    giftingEnabled
    description
  }
`

const buildLessonTypesAndCoachFacilitiesQuery = includeVirtualCoaching => gql`
  query BookingTypesAndCoachAvailabilities {
    lessonTypes {
      ...LessonTypeDetailsFields
      ${includeVirtualCoaching ? VIRTUAL_COACHING_FIELDS : ''}
    }
    coachAvailabilities {
      id
      coachFacility {
        id
        name
      }
      timeSlots {
        day
        startTime
        endTime
      }
    }
    currentUser {
      attributes {
        ... on Coach {
          freeTierLimitsReached
        }
      }
    }
  }
  ${LESSON_TYPE_DETAILS_FIELDS}
`

const GET_LESSON_TYPES_AND_COACH_FACILITIES = buildLessonTypesAndCoachFacilitiesQuery(
  false,
)
const GET_LESSON_TYPES_AND_COACH_FACILITIES_WITH_VIRTUAL_COACHING = buildLessonTypesAndCoachFacilitiesQuery(
  true,
)

const buildLessonTypeDetailsQuery = includeVirtualCoaching => gql`
  query GetLessonTypeDetails($id: ID!) {
    lessonTypes(id: $id) {
      ...LessonTypeDetailsFields
      ${includeVirtualCoaching ? VIRTUAL_COACHING_FIELDS : ''}
    }
  }
  ${LESSON_TYPE_DETAILS_FIELDS}
`

const GET_LESSON_TYPE_DETAILS = buildLessonTypeDetailsQuery(false)
const GET_LESSON_TYPE_DETAILS_WITH_VIRTUAL_COACHING = buildLessonTypeDetailsQuery(
  true,
)

export {
  GET_LESSON_TYPE_DESCRIPTION,
  GET_LESSON_TYPE_DETAILS,
  GET_LESSON_TYPE_DETAILS_WITH_VIRTUAL_COACHING,
  GET_LESSON_TYPES_AND_COACH_FACILITIES,
  GET_LESSON_TYPES_AND_COACH_FACILITIES_WITH_VIRTUAL_COACHING,
  VIRTUAL_COACHING_FIELDS,
}
